var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordShown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.81 0L1.111 15.7l.935.935 3.237-3.237a9.768 9.768 0 004.101.885c6.346 0 9.234-5.666 9.234-5.666l.15-.301-.152-.298s-1.237-2.415-3.869-4.084L17.746.935 16.81 0zM9.384 2.377C3.038 2.377.151 8.043.151 8.043L0 8.344l.152.299s.908 1.768 2.82 3.325l.91-.91a9.793 9.793 0 01-2.365-2.715C1.958 7.561 4.364 3.7 9.384 3.7c.604 0 1.169.059 1.698.158l1.08-1.08a9.903 9.903 0 00-2.778-.401zm7.868 5.94c-.284-.5-1.387-2.243-3.45-3.439L12.18 6.501c.348.522.556 1.145.556 1.816a3.317 3.317 0 01-3.308 3.308 3.266 3.266 0 01-1.816-.556l-1.217 1.217c.188.058.381.126.58.196.704.249 1.484.524 2.41.479 5.02 0 7.426-3.862 7.867-4.644zM9.428 5.01a3.317 3.317 0 00-3.307 3.307c0 .159.014.313.036.465l2.528-2.528 1.208-1.208a3.175 3.175 0 00-.465-.036zm1.985 3.307c0-.308-.07-.597-.194-.855l-2.646 2.646c.258.124.547.194.855.194 1.104 0 1.985-.88 1.985-1.985z",
    fill: "#6373A4"
  })));
}

export default SvgPasswordShown;